import { useQuery } from "@tanstack/react-query";
import { useApp } from "../app-context.tsx";
import { PageHead } from "./PageHead.tsx";
import { DefaultCatalogCard, DefaultEmptyState } from "./defaults.tsx";

export function CatalogPage() {
  const { brand, copy, registry } = useApp();
  const Card = brand.slots?.CatalogCard ?? DefaultCatalogCard;
  const Empty = brand.slots?.EmptyState ?? DefaultEmptyState;
  const q = useQuery({ queryKey: ["catalog", brand.config.id], queryFn: () => registry.catalog() });

  return (
    <section className="page page-catalog">
      <PageHead eyebrow={copy("catalog.eyebrow")} title={copy("catalog.title")} sub={brand.config.tagline || undefined} />
      {q.isLoading && <p className="muted">Loading designs…</p>}
      {q.isError && (
        <Empty
          title="Could not load the catalog"
          body={q.error instanceof Error ? q.error.message : String(q.error)}
          action={
            <button type="button" className="cfg-btn" onClick={() => q.refetch()}>
              Retry
            </button>
          }
        />
      )}
      {q.data && q.data.length === 0 && <Empty title={copy("catalog.empty")} body='Run "pnpm design build packs/<pack>" to publish designs locally.' />}
      {q.data && q.data.length > 0 && (
        <div className="catalog-grid">
          {q.data.map((d) => (
            <Card
              key={d.id}
              entry={{ id: d.id, version: d.version, title: d.title, description: d.description, tags: d.tags, thumbnailUrl: d.thumbnailUrl, href: `/design/${encodeURIComponent(d.id)}`, kind: "design" }}
            />
          ))}
        </div>
      )}
    </section>
  );
}
